const bar = 'bg-secondary-200';

/** Silhouettes des sections de l'accueil, affichées pendant le chargement des données. */
export default function HomeSkeleton() {
  return (
    <div aria-busy aria-label="Chargement de la page" className="animate-pulse">
      {/* Qui sommes-nous */}
      <section className="bg-white py-16 md:py-24">
        <div className="site-container grid gap-12 lg:grid-cols-[1.9fr_1fr] lg:gap-20">
          <div>
            <div className={`h-3 w-32 ${bar}`} />
            <div className={`mt-6 h-12 w-3/4 ${bar}`} />
            <div className="mt-10 space-y-3">{[100, 96, 92, 70].map((w) => <div key={w} className={`h-4 ${bar}`} style={{ width: `${w}%` }} />)}</div>
            <div className={`mt-10 h-12 w-56 ${bar}`} />
          </div>
          <div className="space-y-8">{[0, 1, 2].map((n) => <div key={n}><div className={`h-12 w-24 ${bar}`} /><div className={`mt-3 h-4 w-40 ${bar}`} /></div>)}</div>
        </div>
      </section>

      {/* Mission */}
      <section className="grid bg-charcoal lg:grid-cols-2">
        <div className="min-h-[18rem] bg-secondary-300/40 lg:min-h-[30rem]" />
        <div className="space-y-4 px-6 py-16 md:px-12 lg:px-20 lg:py-24">
          <div className="h-3 w-28 bg-white/20" />
          <div className="h-10 w-4/5 bg-white/20" />
          {[100, 94, 60].map((w) => <div key={w} className="h-4 bg-white/15" style={{ width: `${w}%` }} />)}
        </div>
      </section>

      {/* Réalisations en onglets */}
      <section className="bg-surface py-16 md:py-24">
        <div className="site-container">
          <div className={`h-3 w-40 ${bar}`} />
          <div className={`mt-5 h-10 w-2/3 ${bar}`} />
          <div className="mt-10 flex gap-8">{[28, 36, 24, 30].map((w) => <div key={w} className={`h-5 ${bar}`} style={{ width: `${w * 4}px` }} />)}</div>
          <div className="mt-10 grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
            <div className={`aspect-[4/3] ${bar}`} />
            <div className="space-y-4"><div className={`h-8 w-3/4 ${bar}`} /><div className={`h-4 w-full ${bar}`} /><div className={`h-4 w-5/6 ${bar}`} /><div className={`h-11 w-44 ${bar}`} /></div>
          </div>
        </div>
      </section>

      {/* Engagements */}
      <section className="bg-white py-16 md:py-24">
        <div className="site-container">
          <div className={`h-3 w-36 ${bar}`} />
          <div className={`mt-5 h-10 w-1/2 ${bar}`} />
          <div className="mt-12 grid gap-6 sm:grid-cols-2">{[0, 1, 2, 3].map((n) => <div key={n} className={`h-44 ${bar}`} />)}</div>
        </div>
      </section>

      {/* Secteurs */}
      <section className="bg-surface py-16 md:py-24">
        <div className="site-container">
          <div className={`h-3 w-28 ${bar}`} />
          <div className={`mt-5 h-10 w-1/2 ${bar}`} />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">{[0, 1, 2, 3].map((n) => <div key={n} className={`aspect-[4/5] ${bar}`} />)}</div>
        </div>
      </section>
    </div>
  );
}
